import WorldQ from '@/queries/WorldQ'
import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'

import { worldDetailsFromQuery } from '@/components/Worlds/transforms/detailsFromQueries'
import type { WorldBase } from '@/components/Worlds/types'

export default function useWorldSlugToWorld({ worldSlugs }: { worldSlugs: string[] }): WorldBase[] {
  const currentUser = useUser()
  const query = useQuery()

  const worldList = query.many(WorldQ.where({}, WorldQ.hasAnySlug(worldSlugs))).map(world =>
    worldDetailsFromQuery(['id', 'slug', 'iconUrl', 'title', 'primaryColor'], {
      world,
      userId: currentUser.id,
    })
  )

  return worldList
}
